export function Chips({ items, value, onChange, testid }) {
  if (!items.length) return <div className="text-xs text-slate-500">None set up yet.</div>;
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map(([k, l]) => (
        <button type="button" key={k} onClick={() => toggle(k)} data-testid={`${testid}-${k}`}
          className={`px-2.5 py-1 rounded-md text-xs border cursor-pointer transition-colors ${value.includes(k) ? "border-[#C2A462] bg-[#C2A462]/15 text-[#EBD6A0]" : "border-white/10 text-slate-400 hover:border-[#C2A462]/50 hover:text-slate-200"}`}>{value.includes(k) ? "✓ " : "+ "}{l}</button>
      ))}
    </div>
  );
}
